import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DialogComponent } from '@kpmg-ux/ngx-tax-design-system';
import { AutoLogoutService } from '../../auth/services/auto-logout-service';

@Component({
  selector: 'app-logout-prompt',
  templateUrl: './logout-prompt.component.html',
  styleUrls: ['./logout-prompt.component.css']
})
export class LogoutPromptComponent implements OnInit {
  counter: number;
  isUserConfirmationPeding: boolean;
  minutes: number;
  @Input('isTimeOut') set 'isTimeOut'(value: boolean) {
    if (value) {
      this.alertUser();
    }
  }
  @ViewChild('mdlSession') mdlSessionDialog: DialogComponent;
  constructor(private _autoLogoutService: AutoLogoutService) { }

  ngOnInit() {

  }

  alertUser() {
    this.isUserConfirmationPeding = true;
    this.mdlSessionDialog.showDialog();
    this.counter = 60;
    this.minutes=4;    
    this.initiateCountDown()
  }
  initiateCountDown() {
    if (this.isUserConfirmationPeding) {
      this.counter = this.counter - 1;     
      if(this.counter==0){
        this.minutes=this.minutes-1;
        if(this.minutes>=0){
          this.counter=59;
        }
      }
      if (this.counter >= 1) {
        setTimeout(() => { this.initiateCountDown(); }, 1000);
      } else {
        this.logOut();
      }
    }
  }

  continueSession() {
    this.mdlSessionDialog.hideDialog();
    this.isUserConfirmationPeding = false;
    this._autoLogoutService.continueSession();
  }

  logOut() {

    this.mdlSessionDialog.hideDialog();
    this.isUserConfirmationPeding = false;
    this._autoLogoutService.logOutSession();

  }

}
